import { useState } from "react";
import { motion } from "framer-motion";
import { Pencil, Trash2 } from "lucide-react";
import CountdownRing from "./CountdownRing";

export default function VehicleCard({ vehicle, index, onEdit, onDelete, onRenew }) {
  const [confirming, setConfirming] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.06, ease: [0.16, 1, 0.3, 1] }}
      className="rounded-2xl border border-line bg-panel p-5 hover:border-linehi transition-colors"
      data-testid={`vehicle-card-${vehicle.id}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <span className="uk-plate inline-block rounded px-2 py-1 text-sm font-bold" data-testid={`vehicle-vrm-${vehicle.id}`}>
            {vehicle.plate}
          </span>
          <h3 className="font-display text-2xl font-bold uppercase tracking-wide mt-2 truncate">
            {[vehicle.make, vehicle.model].filter(Boolean).join(" ") || vehicle.name}
          </h3>
          <p className="text-xs text-mid mt-0.5 truncate">
            {vehicle.name} · {vehicle.category}
            {vehicle.year ? ` · ${vehicle.year}` : ""}
          </p>
        </div>
        <div className="flex gap-1.5 shrink-0">
          <button
            data-testid={`edit-vehicle-${vehicle.id}`}
            onClick={() => onEdit(vehicle)}
            className="p-2 rounded-lg border border-line text-mid hover:text-hi hover:border-linehi transition"
            aria-label="Edit vehicle"
          >
            <Pencil className="w-3.5 h-3.5" />
          </button>
          <button
            data-testid={`delete-vehicle-${vehicle.id}`}
            onClick={() => (confirming ? onDelete() : setConfirming(true))}
            onBlur={() => setConfirming(false)}
            className={`p-2 rounded-lg border transition ${confirming ? "border-ember text-ember" : "border-line text-mid hover:text-ember hover:border-ember"}`}
            aria-label="Delete vehicle"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 mt-6">
        <CountdownRing fieldId="mot_due" vehicleId={vehicle.id} label="MOT" count={vehicle.counts?.mot_due} onRenew={() => onRenew(vehicle, "mot_due")} />
        <CountdownRing fieldId="council_due" vehicleId={vehicle.id} label="Council" count={vehicle.counts?.council_due} onRenew={() => onRenew(vehicle, "council_due")} />
        <CountdownRing fieldId="tax_due" vehicleId={vehicle.id} label="Road tax" count={vehicle.counts?.tax_due} onRenew={() => onRenew(vehicle, "tax_due")} />
      </div>

      {confirming && (
        <p className="mt-3 font-mono text-[10px] uppercase tracking-widest text-ember">
          Click delete again to confirm
        </p>
      )}
      {vehicle.notes && (
        <p className="mt-4 text-xs text-low border-t border-line pt-3">{vehicle.notes}</p>
      )}
    </motion.div>
  );
}
